const parsableString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const getItem = (key) => {
    try {
        // Get from local storage by key
        const item = window.localStorage.getItem(key);
        // Parse stored json or if none return initialValue
        return (parsableString(item) && JSON.parse(item)) || item || "";
    } catch (error) {
        // If error also return initialValue
        throw error;
    }
};

export const setItem = (key, value) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        throw error;
    }
};

export const removeItem = (key) => {
    try {
        window.localStorage.removeItem(key);
    } catch (error) {
        throw error;
    }
};
